import type { OrderChannel, OrderStatus, PromotionStatus, PromotionType, StockStatus } from '@khaddi/domain';

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  pending_payment: 'Chờ thanh toán',
  new: 'Mới',
  brewing: 'Đang pha',
  awaiting_shipper: 'Chờ shipper',
  shipper_assigned: 'Shipper đã nhận',
  delivering: 'Đang giao',
  completed: 'Hoàn tất',
  cancelled: 'Đã hủy',
};

/** Customer-facing wording for the tracking timeline. */
export const ORDER_TRACKING_LABELS: Record<OrderStatus, string> = {
  pending_payment: 'Đang chờ thanh toán',
  new: 'Đã đặt đơn, chờ quán nhận',
  brewing: 'Quán đã nhận đơn & đang pha',
  awaiting_shipper: 'Đang tìm shipper',
  shipper_assigned: 'Shipper đang đến quán',
  delivering: 'Đang giao đến bạn',
  completed: 'Đã giao thành công',
  cancelled: 'Đơn đã hủy',
};

export const CHANNEL_LABELS: Record<OrderChannel, string> = {
  app_delivery: 'App · giao',
  app_pickup: 'App · tại quán',
  counter: 'Tại quầy',
};

export const STOCK_LABELS: Record<StockStatus, string> = {
  in_stock: 'Còn hàng',
  low_stock: 'Sắp hết',
  sold_out_today: 'Hết hàng hôm nay',
  discontinued: 'Ngừng bán',
};

export const PROMOTION_TYPE_LABELS: Record<PromotionType, string> = {
  percent: 'Giảm % / số tiền',
  happy_hour: 'Giảm theo giờ',
  buy_x_get_y: 'Mua X tặng Y',
  voucher: 'Mã voucher',
  freeship: 'Freeship',
  combo: 'Combo',
};

export const PROMOTION_STATUS_LABELS: Record<PromotionStatus, string> = {
  draft: 'Nháp',
  scheduled: 'Lên lịch',
  active: 'Đang chạy',
  paused: 'Tạm dừng',
  ended: 'Đã kết thúc',
};

export const OPTION_GROUP_LABELS = {
  size: 'Size',
  sugar: 'Độ ngọt',
  ice: 'Đá',
  topping: 'Topping',
  temperature: 'Nóng / lạnh',
} as const;

/** Badge colours per status, from the console design. */
export const ORDER_STATUS_TONES: Record<OrderStatus, { bg: string; fg: string }> = {
  pending_payment: { bg: '#EEF1F3', fg: '#5A6B78' },
  new: { bg: '#FDE8E7', fg: '#9E2A22' },
  brewing: { bg: '#FDF6DD', fg: '#6B5310' },
  awaiting_shipper: { bg: '#E8F1F7', fg: '#2A6184' },
  shipper_assigned: { bg: '#E8F1F7', fg: '#2A6184' },
  delivering: { bg: '#E3EEF5', fg: '#1C455F' },
  completed: { bg: '#EAF5EF', fg: '#1F5A40' },
  cancelled: { bg: '#EEF1F3', fg: '#5A6B78' },
};

export const TIER_TONES: Record<string, { bg: string; fg: string }> = {
  'Đồng': { bg: '#F4E6DA', fg: '#7A4E35' },
  'Bạc': { bg: '#EEF1F3', fg: '#3E4E5B' },
  'Vàng': { bg: '#FDF6DD', fg: '#6B5310' },
  'Kim cương': { bg: '#E3EEF5', fg: '#1C455F' },
};

/** Badge colours for a tier: the classic four keep their palette, owner-made tiers derive one from their colour. */
export const tierTone = (name: string, color?: string): { bg: string; fg: string } =>
  TIER_TONES[name] ?? (color ? { bg: `${color}22`, fg: color } : { bg: '#EEF1F3', fg: '#3E4E5B' });
